
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sitemap-dynamic.xml",
      function () {
        return require("private-next-pages/sitemap-dynamic.xml.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sitemap-dynamic.xml"])
      });
    }
  